import { useEffect, useRef } from 'react';
import { useSetCurrencyStore } from 'pricing-pages-ui/context/CurrencyContext';
import { useCurrency } from './CurrencyContext';

/*
 * Syncs the public CurrencyContext into the in-app CurrencyStore so page
 * components that call useGetCurrencyStore() reflect URL-driven changes.
 * Sits below both providers; removed once in-app pages are replaced (#19831+).
 */
export function PublicCurrencySyncBridge() {
  const {
    displayedCurrencyCode,
    availableCurrencyCodes,
    countryCode
  } = useCurrency();
  const setStore = useSetCurrencyStore();
  const setStoreRef = useRef(setStore);
  // eslint-disable-next-line react-hooks/refs
  setStoreRef.current = setStore;
  useEffect(() => {
    setStoreRef.current({
      displayedCurrencyCode,
      availableCurrencyCodes,
      countryCode
    });
  }, [displayedCurrencyCode, availableCurrencyCodes, countryCode]);
  return null;
}